import React, { ReactComponentElement } from "react";

import { Link } from "common/types/routing";

import RowLayout from "./RowLayout";
import RowLayoutLink from "./RowLayoutLink";

type Props = {
  link: Link;
  depth?: 0 | 1 | 2;
  active?: boolean;
  onClick?: () => void;
  disabled?: boolean;
  children: {
    title: ReactComponentElement<any, any> | ReactComponentElement<any, any>[];
    indicator:
      | ReactComponentElement<any, any>
      | ReactComponentElement<any, any>[]
      | null;
  };
};

export default function RowLayoutLinkConditional({
  active,
  link,
  ...props
}: Props) {
  // @ts-ignore
  if (active) return <RowLayout active {...props} />;
  // @ts-ignore
  else return <RowLayoutLink {...props} link={link} />;
}
